import { Link } from "react-router-dom";

import { MODELS } from "@mywheels/common/lib/cars/models";
import {
  addTranslationData,
  useTranslation,
} from "@mywheels/common/lib/translation";

import { ToolbarSpacer } from "web/layout/Toolbar";
import { useRoutes } from "web/lib/i18n";
import { ElectricIcon } from "web/ui/icons/ElectricIcon";
import { useScrollToTop } from "web/ui";
import { Car } from "@mywheels/common/lib/cars/types";

addTranslationData({
  en: {
    Handleidingen: "Car manuals",
    _car_manuals_intro:
      "Don't know what that blinking warning light is about? Or how to tank or charge your car? We've got you. Each of our cars comes with a complete & detailed manual. Have a nice trip!",
  },
  nl: {
    _car_manuals_intro:
      "Weet je even niet wat het waarschuwingslampje betekent, of hoe je de auto moet tanken of opladen? We've got you. Bij al onze auto's hebben we een handleiding, met alles wat je moet weten, overzichtelijk bij elkaar. Een fijne rit gewenst!",
  },
});

const IMAGE_BASE_PATH =
  "https://storage.googleapis.com/mw_production_assets/img/cars/";

export default function CarManualsOverviewPage() {
  const { t } = useTranslation();

  useScrollToTop();

  return (
    <div>
      <ToolbarSpacer />

      <div className="my-8 md:my-12 mx-4">
        <h1 className="text-center md:text-4xl lg:text-5xl mb-4">
          {t("Handleidingen")}
        </h1>
        <p className="text-gray600 text-center text-sm md:text-base lg:text-lg mx-auto max-w-[860px]">
          {t("_car_manuals_intro")}
        </p>
      </div>

      <div className="container">
        <div className="row">
          {MODELS.map((car) => {
            return <CarManualLink key={car.id} car={car} />;
          })}
        </div>
      </div>
    </div>
  );
}

function CarManualLink({ car }: { car: Car }) {
  const { language } = useTranslation();
  const imageSrc = `${IMAGE_BASE_PATH}${car.id.replace(/_/g, "-")}/default.png`;
  const routes = useRoutes();
  if (!car.intercomManualId) {
    return (
      <div
        key={car.id}
        className="col-6 md:col-4 lg:col-3 mb-2 lg:mb-6 text-center"
      >
        <Link
          to={routes.CarManual.url({ carId: car.id })}
          className="block p-2 md:p-3 hover:bg-gray50 rounded-lg focus:ring-2 focus:ring-blue focus:outline-none"
        >
          <img
            className="-mt-1 mx-auto block w-[100px] h-[55px] md:w-[140px] md:h-[77px] lg:w-[180px] lg:h-[99px]"
            src={imageSrc}
            alt={`${car.brand} ${car.model}`}
          />
          <div className="font-display md:text-lg lg:text-xl text-blue">
            {car.brand}{" "}
            <span className="whitespace-nowrap">
              {car.model}
              {car.electric && (
                <ElectricIcon className="ml-2 nudge-up text-green" />
              )}
            </span>
          </div>
        </Link>
      </div>
    );
  }

  const intercomManualUrl = `https://help.mywheels.nl/${
    language === "nl" ? "nl" : "en"
  }/collections/${car.intercomManualId}`;

  return (
    <div
      key={car.id}
      className="col-6 md:col-4 lg:col-3 mb-2 lg:mb-6 text-center"
    >
      <a
        href={intercomManualUrl}
        className="block p-2 md:p-3 hover:bg-gray50 rounded-lg focus:ring-2 focus:ring-blue focus:outline-none"
      >
        <img
          className="-mt-1 mx-auto block w-[100px] h-[55px] md:w-[140px] md:h-[77px] lg:w-[180px] lg:h-[99px]"
          src={imageSrc}
          alt={`${car.brand} ${car.model}`}
        />
        <div className="font-display md:text-lg lg:text-xl text-blue">
          {car.brand}{" "}
          <span className="whitespace-nowrap">
            {car.model}
            {car.electric && (
              <ElectricIcon className="ml-2 nudge-up text-green" />
            )}
          </span>
        </div>
      </a>
    </div>
  );
}
